var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiscoverAndResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0343 0.596196L2.38202 4.48261C1.20346 4.62732 0.365357 5.70004 0.510066 6.8786L4.39648 38.5309C4.54119 39.7095 5.61391 40.5476 6.79247 40.4029L38.4448 36.5164C39.6233 36.3717 40.4614 35.299 40.3167 34.1204L36.4303 2.46815C36.2856 1.28959 35.2129 0.451487 34.0343 0.596196Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84961 12.4499C8.26961 12.3299 18.4996 10.7799 21.7896 10.2099C25.3055 9.60043 28.8501 9.16987 32.4096 8.91992",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29004 19.4902C11.2653 19.2057 15.2193 18.678 19.13 17.9102",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 37.17C10.2772 35.6907 10.1735 34.1959 10.1901 32.7C10.1698 32.4042 10.2358 32.1089 10.3801 31.85C10.7701 31.28 11.6401 31.49 12.3101 31.34C12.3866 31.3316 12.4606 31.3077 12.5276 31.2699C12.5947 31.2321 12.6533 31.1811 12.7001 31.12C12.7702 30.9468 12.7702 30.7532 12.7001 30.58L12.5001 29.04C12.2731 28.1949 12.3151 27.3001 12.6201 26.48C13.1912 25.6254 14.0557 25.0099 15.0501 24.75",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6698 36.73L52.6698 45.39C52.9274 45.6431 53.132 45.9451 53.2716 46.2782C53.4113 46.6112 53.4833 46.9688 53.4833 47.33C53.4833 47.6912 53.4113 48.0487 53.2716 48.3818C53.132 48.7149 52.9274 49.0168 52.6698 49.27C52.4178 49.5243 52.118 49.7261 51.7876 49.8638C51.4572 50.0016 51.1027 50.0725 50.7448 50.0725C50.3868 50.0725 50.0324 50.0016 49.702 49.8638C49.3716 49.7261 49.0717 49.5243 48.8198 49.27L39.7598 40.21",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 14.1099C25.2099 14.1099 19.1299 20.7499 19.1299 28.2499C19.1299 36.4299 25.2099 41.5499 32.6999 41.8199C41.1599 42.1299 46.2799 35.7399 46.2799 28.2499C46.2799 19.7099 40.1999 14.1099 32.6999 14.1099ZM32.9199 37.6299C31.6542 37.6381 30.3996 37.393 29.23 36.9091C28.0604 36.4251 26.9995 35.7121 26.1096 34.812C25.2197 33.9118 24.5189 32.8428 24.0484 31.6677C23.5779 30.4927 23.3472 29.2354 23.3699 27.9699C23.3263 26.7249 23.5365 25.4842 23.9878 24.3231C24.439 23.162 25.1218 22.1049 25.9947 21.2162C26.8675 20.3274 27.9121 19.6256 29.0649 19.1535C30.2176 18.6813 31.4544 18.4487 32.6999 18.4699C33.9859 18.4672 35.2598 18.7183 36.4487 19.2086C37.6375 19.6989 38.718 20.4189 39.6283 21.3273C40.5386 22.2357 41.2608 23.3147 41.7535 24.5026C42.2463 25.6905 42.4999 26.9639 42.4999 28.2499C42.4999 34.0099 38.3199 37.6299 32.9199 37.6299Z",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.5,
    height: 49.99,
    fill: "white",
    transform: "translate(0.5 0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscoverAndResearch);
export default __webpack_public_path__ + "static/media/icon-discover-and-research.353033f0c296bf911d1b724a1cbc2938.svg";
export { ForwardRef as ReactComponent };